import { createAsyncThunk } from "@reduxjs/toolkit";
import sdkProvider from "../../../../client/sdkProvider";
import logger from "../../../../lib/logger";
import getIsBenefitEventActive from "../selectors/getIsBenefitEventActive";

const loadLoyaltyIsBenefitEventActive = createAsyncThunk(
  "config/loadLoyaltyIsBenefitEventActive",
  async (loyaltyBenefitType, { rejectWithValue }) => {
    try {
      const loyaltySdk = await sdkProvider("loyalty");
      const config = await loyaltySdk.getConfig();
      const isActive = getIsBenefitEventActive(config, loyaltyBenefitType);

      return { isActive, loyaltyBenefitType };
    } catch (error) {
      if (error.name !== "LoyaltyNotSupportedError") {
        error.message = `loadLoyaltyIsBenefitEventActive failed with error: ${error.message}`;
        logger.error(error);
      }

      return rejectWithValue(error);
    }
  },
);

export default loadLoyaltyIsBenefitEventActive;
